import React, {useEffect, useState} from 'react';
import '../SellFactor.scss';
import AddProductSection from "./AddProductSection";
import FactorTableJozNEW from "./FactorTableJozNEW";
import {calculateTotalSum} from "../SellFactorFunctions";
import {formatToPersianAddComma} from "../../../utils/CommaSeparator";

const SellFactorJOZ = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {

  const [sum, setSum] = useState({sum: 0, taxPrice: 0});
  useEffect(() => {
    setSum(isNaN(calculateTotalSum(sendData).sum) ? sum : calculateTotalSum(sendData))
  }, [sendData])

  try {
    return (
      <>
        <div className="total buy-fac-joz">
          <AddProductSection
            sendData={sendData} setSendData={setSendData} initialData={initialData}
            componentData={componentData} setComponentData={setComponentData}
            storeRoomType={'sell'}
            mode={"sell"}
          />
          <div className="separate-factor__newSellComponent">
            <FactorTableJozNEW
              sendData={sendData} setSendData={setSendData} initialData={initialData}
              componentData={componentData} setComponentData={setComponentData}
            />
            <div className={'box-price-total '}>
              {sum.sum - sum.taxPrice > 0 &&
                <div className='box-price'><p>جمع کالا :</p> {formatToPersianAddComma(sum.sum - sum.taxPrice)}</div>}
              {sum.taxPrice > 0 &&
                <div className='box-price'><p>مبلغ مالیات :</p> {formatToPersianAddComma(sum.taxPrice)}</div>}
              {+sendData?.usedRemaining > 0 &&
                <div className='box-price'><p>مبلغ باشگاه مشتریان
                  :</p> {formatToPersianAddComma(sendData.usedRemaining)}</div>}
              <div className='box-price main-total'><p>جمع کل
                :</p> {formatToPersianAddComma(sum.sum - +sendData?.usedRemaining)}</div>
            </div>
          </div>
        </div>
      </>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default React.memo(SellFactorJOZ);
